// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2aDvb","title":"Info_title__2qPkF","links":"Info_links__2KlpM","link":"Info_link__103GG","logo":"Info_logo__34QnT"};